import { render, staticRenderFns } from "./DeliveryWaitingLater.vue?vue&type=template&id=6b6ec4c5&"
import script from "./DeliveryWaitingLater.vue?vue&type=script&lang=js&"
export * from "./DeliveryWaitingLater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports